



























import { Component, Vue } from 'vue-property-decorator'

@Component
export default class DynamicRoutePage extends Vue {
  created () {
    // console.log('dynamic-route created')
  }

  mounted () {
    // console.log('dynamic-route mounted')
  }
}
